// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
//
// Page « Nouveautés » — le registre complet, source de vérité.
//
// Le pop-up ne montre que la dernière version notable et disparaît une fois
// fermé. Sans cette page, un client qui l'a fermé n'aurait aucun moyen de
// retrouver ce qui a changé, et les versions non notables (correctifs) n'auraient
// nulle part où être publiées.
import React from 'react';
import { Sparkles } from 'lucide-react';
import { useI18n } from '../i18n';
import { CHANGELOG, APP_VERSION } from '../data/changelog';

const Nouveautes = () => {
  const { t, lang } = useI18n();

  const texte = (bloc) => bloc?.[lang] ?? bloc?.fr ?? '';

  // Donnée ISO formatée à l'affichage, comme dans le pop-up et le bandeau de
  // fin de droits — jamais de date écrite en toutes lettres dans le code.
  const formatDate = (iso) => {
    const [a, m, j] = iso.split('-');
    return new Date(Number(a), Number(m) - 1, Number(j)).toLocaleDateString(
      lang === 'en' ? 'en-GB' : 'fr-FR',
      { year: 'numeric', month: 'long', day: 'numeric' }
    );
  };

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '28px 32px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
          <Sparkles size={20} style={{ color: 'var(--gold, #c9a227)' }} />
          <h1 style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>{t('whatsnew_page_title')}</h1>
        </div>
        <p style={{ fontSize: 13, color: 'var(--text-muted, #6b7280)', margin: '0 0 28px 0' }}>
          {t('whatsnew_page_subtitle')} · {t('whatsnew_version')} {APP_VERSION}
        </p>

        {CHANGELOG.map((v) => (
          <section key={v.version} style={{ marginBottom: 32 }}>

            <div style={{
              display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap',
              paddingBottom: 8, borderBottom: '1px solid var(--border, #e5e7eb)', marginBottom: 14,
            }}>
              <span style={{
                fontSize: 13, fontWeight: 700, color: 'var(--gold, #c9a227)',
                letterSpacing: 0.3,
              }}>
                {t('whatsnew_version')} {v.version}
              </span>
              <span style={{ fontSize: 12, color: 'var(--text-muted, #6b7280)' }}>
                {formatDate(v.date)}
              </span>
            </div>

            <p style={{ fontSize: 15, fontWeight: 500, margin: '0 0 12px 0', lineHeight: 1.45 }}>
              {texte(v.titre)}
            </p>

            <ul style={{ margin: 0, paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 10 }}>
              {v.entrees.map((e, i) => (
                <li key={i} style={{ fontSize: 13.5, lineHeight: 1.55 }}>{texte(e)}</li>
              ))}
            </ul>

          </section>
        ))}

      </div>
    </div>
  );
};

export default Nouveautes;
